import React, {Component} from 'react';
import {Card, CardActions} from "@material-ui/core/index";
import Button from "@material-ui/core/Button/Button";
import CardContent from "@material-ui/core/CardContent/CardContent";
import TextField from "@material-ui/core/TextField/TextField";
import Loading from '../loading/loading';
import Snackbar from '@material-ui/core/Snackbar';
import CardHeader from "@material-ui/core/CardHeader/CardHeader";

const style = {
  container: {
    height: '100vh',
  },
  refresh: {
    position: 'fixed',
    top: '80%',
    left: '50%',
    transform: 'translateX(-50%)'
  },
  formContainer: {
    maxWidth: '400px',
  }
};


class Login extends Component{
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: ''
    };
  }

  _onInputChange = (evt) => {
    this.setState(
      {
        ...this.state,
        [evt.target.name]: evt.target.value
      }
    );
  };

  _login = (evt) => {
    evt.preventDefault();
    this.props.login({
      username: this.state.username,
      password: this.state.password,
    })
  };

  render(){
    return (
      <div style={style.container}>
        <div className={'container d-flex h-100'}>
          <div className={'row justify-content-center align-self-center  ml-auto mr-auto'}>
            <Card className={'p-3'} style={style.formContainer}>
              <CardHeader
                title={'Login '}
              />
              <CardContent>
                <form id="loginForm" className={'form-horizontal'} onSubmit={this._login}>
                  <TextField
                    label="Username"
                    name={'username'}
                    value={this.state.username}
                    onChange={this._onInputChange}
                    type="text"
                    fullWidth={true}
                    margin={"normal"}
                  />
                  <TextField
                    fullWidth={true}
                    label="Password"
                    name={'password'}
                    value={this.state.password}
                    onChange={this._onInputChange}
                    type="password"
                    margin={"normal"}
                  />
                </form>
              </CardContent>
              <CardActions>
                <Button form="loginForm" variant="contained" color={"primary"} type={'submit'}>
                  Sign in
                </Button>
              </CardActions>
            </Card>

            <Loading displayLoader={this.props.loggingIn}/>
          </div>
        </div>
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={!!this.props.loggingInResponseMessage}
          onClose={() => { this.props.changeUserStoreSettings({
            key: 'loggingInResponseMessage',
            value: ''
          }) }}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{this.props.loggingInResponseMessage}</span>}
        />
      </div>
    )
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/login.js